import { display } from "redux-react/reducers/snackBarReducer";
import { api } from "./api";
import { t } from "i18next";

const actions = {
	deleteSources: (codes, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "DELETE",
					url: `/faiq/api/v1/source/many`,
					data: {
						sources: codes
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: t("SOURCES.DELETE.CALLS.error")
							})
						);
					}
				})
			);
		};
	},
	/* Update one source */
	updateSource: (code, data, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/faiq/api/v1/source`,
					data: {
						code,
						update: data
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: t("SOURCES.UPDATE.CALLS.error")
							})
						);
					}
				})
			);
		};
	},
	/* Update many sources */
	updateSources: (codes, data, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/faiq/api/v1/source/many`,
					data: {
						codes,
						update: data
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: t("SOURCES.UPDATE.CALLS.errorMany")
							})
						);
					}
				})
			);
		};
	},
	/* Get the channels integration */
	getIntegrationChannels: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/source/integration/channels`,
					data,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure
				})
			);
		};
	},
	/* Get sitemap */
	getIntegrationSitemap: (url, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/source/integration/sitemap`,
					data: {
						url
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure
				})
			);
		};
	},
	/* Get sitemap from asset */
	getIntegrationSitemapFromAsset: (code, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/source/integration/sitemap/asset`,
					data: {
						code
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure
				})
			);
		};
	},
	/* Get URL */
	getIntegrationWebURL: (url, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/source/integration/url`,
					data: {
						url
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure
				})
			);
		};
	},
	/* Check if sources exist in database */
	checkIfSourcesExist: (sources, onSuccess, onFailure) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/source/integration/exists`,
					data: {
						sources
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						onFailure(err);
					}
				})
			);
		};
	},
	/* Save sources */
	importSources: (data, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/source/import`,
					data,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: t("SOURCES.IMPORT.error")
							})
						);
					}
				})
			);
		};
	},
	/* Get shopify resource for channel */
	getShopifyResourceForChannel: (
		resource,
		assistantID,
		channelCode,
		onSuccess,
		onFailure = () => {}
	) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/faiq/api/v1/source/integration/channels/shopify/${resource}/${assistantID}/${channelCode}`,
					data: {},
					onSuccess,
					onFailure
				})
			);
		};
	},

	createFolder: (folder, assistantID, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/folder/create`,
					data: { folder },
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: t("SOURCES.FOLDER.CREATE.error")
							})
						);
					}
				})
			);
		};
	},

	updateFolder: (folder, assistantID, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/folder/update`,
					data: { folder },
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: t("SOURCES.IMPORT.error")
							})
						);
					}
				})
			);
		};
	},

	deleteFolder: (resource, assistantID, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/folder/delete`,
					data: resource,
					onSuccess: res => {
						onSuccess(res?.folders);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: t("SOURCES.IMPORT.error")
							})
						);
					}
				})
			);
		};
	},
	/* Get folders for assistant */
	getFolders: (onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/faiq/api/v1/folders`,
					data: {},
					onSuccess: res => {
						onSuccess(res?.folders);
					},
					onFailure
				})
			);
		};
	},

	createAsset: (file, assistantID, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/source/asset/create`,
					data: file,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: t("SOURCES.ASSET.CREATE.error")
							})
						);
					}
				})
			);
		};
	},

	createManyAssets: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/source/asset/create/many`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},

	getAssetsByFolderId: (folderId, assistantID, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/faiq/api/v1/source/assets/${folderId}`,
					data: {},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: t("SOURCES.ASSET.GET_BY_FOLDER.error")
							})
						);
					}
				})
			);
		};
	},

	// Supprimer un asset
	deleteAsset: (assetId, assistantID, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "DELETE",
					url: `/faiq/api/v1/source/asset/${assetId}`,
					data: {},
					onSuccess: res => {
						dispatch(
							display({
								type: "success",
								message: t("SOURCES.ASSET.DELETE.success")
							})
						);
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: t("SOURCES.ASSET.DELETE.error")
							})
						);
					}
				})
			);
		};
	},

	// Delete many assets
	deleteAssets: (list, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "DELETE",
					url: `/faiq/api/v1/source/assets`,
					data: {
						assetsID: list
					},
					onSuccess: res => {
						dispatch(
							display({
								type: "success",
								message: t("SOURCES.ASSET.DELETE.success")
							})
						);
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: t("SOURCES.ASSET.DELETE.error")
							})
						);
					}
				})
			);
		};
	},

	// Mettre à jour un asset
	updateAsset: (assetId, data, onSuccess, onFailure) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/faiq/api/v1/source/asset/${assetId}`,
					data: { asset: data },
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						if (onFailure) {
							onFailure(err);
						} else {
							dispatch(
								display({
									type: "error",
									message: t("SOURCES.ASSET.UPDATE.error")
								})
							);
						}
					}
				})
			);
		};
	},

	// Update many assets
	updateAssets: (list, data, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/faiq/api/v1/source/assets`,
					data: { list, asset: data },
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: t("SOURCES.ASSET.UPDATE.error")
							})
						);
					}
				})
			);
		};
	},

	getAssets: (resource, assistantID, onSuccess, filtre = {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/faiq/api/v1/source/assets/${resource}/${assistantID}`,
					data: { ...filtre },
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: t("SOURCES.ASSET.GET.error")
							})
						);
					}
				})
			);
		};
	},

	/* Convert asset to source */
	convertAssetToSource: (code, extra = {}, onSuccess = () => {}, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/source/integration/asset`,
					data: {
						code,
						extra
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Convert many asset to source */
	convertAssetsToSource: (list, extra = {}, onSuccess = () => {}, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/source/integration/assets`,
					data: {
						list,
						extra
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Convert asset to source */
	updateSourceWithAssetContent: (code, onSuccess = () => {}, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/source/update/asset`,
					data: {
						code
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Delete sources asset */
	deleteSourcesAsset: (code, onSuccess = () => {}, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "DELETE",
					url: `/faiq/api/v1/source/from/asset/${encodeURIComponent(code)}`,
					data: {},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Wordpress  */
	getIntegrationWordpress: (url, data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/source/integration/wordpress`,
					data: {
						url,
						type: data.type
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Move asset to new folder */
	moveAssets: (assetsId, folderId, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/asset/move`,
					data: { assetsId, folderId },
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Check if media file is valid
	 */
	validateMediaFile: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/source/validate/media`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	}
};

export default actions;
